export default class KickoffIntoActiveDrive extends Error {
    constructor() {
        super("Kickoff cannot to be added to an active drive");
    }
}
